import { hasValue } from "@repo/helpers";
import { Col, Loading } from "@repo/ui";
import { useState } from "react";

import { useRepQueries } from "../../../api/repApi";
import { useRepContext } from "../../../contexts/editableItemContext";
import { useSegmentContext } from "../../../contexts/segmentContext";
import { RecentEnrollmentsGrid } from "./recentEnrollmentsGrid";
import { RecentEnrollmentsList } from "./recentEnrollmentsList";
import { RecentEnrollmentsMap } from "./recentEnrollmentsMap";
import style from "./style.module.scss";

export function RecentEnrollmentsView() {
	const [selected, setSelected] = useState<number>();
	const [hovered, setHovered] = useState<number>();

	const { rep } = useRepContext();
	const repLoaded = hasValue(rep?.branchId);

	if (repLoaded && !rep.totalSales) return <div>No Sales</div>;

	return (
		<Loading loading={!repLoaded} message="Loading Enrollments...">
			<div className={style.summaryContainer}>
				<table className={style.table}>
					<thead>
						<tr>
							<td>
								<b>Summary</b>
							</td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr key="total">
							<td>
								<b>Total Sales</b>
							</td>
							<td>{rep.totalSales}</td>
						</tr>
						<tr key="totalGood">
							<td>
								<b>Good Sales</b>
							</td>
							<td>{rep.totalGoodSales}</td>
						</tr>
						<tr key="totalNo">
							<td>
								<b>No Sales</b>
							</td>
							<td>{rep.totalNoSales}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div className={style.detailsContainer}>
				<Col md={3}>
					<RecentEnrollmentsList
						selected={selected}
						hovered={hovered}
						onSelect={setSelected}
						onHover={setHovered}
					/>
				</Col>
				<Col md={9} className={style.mapContainer}>
					<RecentEnrollmentsMap
						selected={selected}
						hovered={hovered}
						onSelect={setSelected}
						onHover={setHovered}
					/>
				</Col>
				<RecentEnrollmentsGrid />
			</div>
		</Loading>
	);
}

export function useRepEnrollmentQuery() {
	const { segmentId } = useSegmentContext();
	const { useRecentEnrollmentsQuery } = useRepQueries();

	return useRecentEnrollmentsQuery(segmentId);
}
